"use strict";
exports.__esModule = true;
exports.global_BorderColor_200 = {
  "name": "--pf-v5-global--BorderColor--200",
  "value": "#8a8d90",
  "var": "var(--pf-v5-global--BorderColor--200)"
};
exports["default"] = exports.global_BorderColor_200;